/**
 * BlockAboutNewsLetter
 *
 * Form-creator (ajax with jquery): https://app.ungapped.com/Web/SubscriptionForms
 */
const BlockAboutNewsLetter = {
  formEl: null,
  emailEl: null,
  doubleOptIdEl: null,
  policyEl: null,
  responseDiv: null,
  successText: "",
  errorTerms: "",
  errorGeneric: "",
  errorEmailEmpty: "",
  errorEmailWrong: "",
  errorSubscriber: "",

  init: () => {
    // get elements
    BlockAboutNewsLetter.formEl = document.getElementById("block-about__form");
    BlockAboutNewsLetter.emailEl = document.getElementById(
      "block-about__contact-email",
    );
    BlockAboutNewsLetter.doubleOptIdEl =
      document.getElementById("double-opt-id");
    BlockAboutNewsLetter.policyEl = document.getElementById(
      "block-about__contact-consent-text",
    );
    BlockAboutNewsLetter.responseDiv = document.getElementById(
      "block-about__response",
    );

    // get validation strings
    if (BlockAboutNewsLetter.responseDiv) {
      BlockAboutNewsLetter.successText =
        BlockAboutNewsLetter.responseDiv.dataset.successText;
      BlockAboutNewsLetter.errorTerms =
        BlockAboutNewsLetter.responseDiv.dataset.errorTerms;
      BlockAboutNewsLetter.errorGeneric =
        BlockAboutNewsLetter.responseDiv.dataset.errorGeneric;
      BlockAboutNewsLetter.errorEmailEmpty =
        BlockAboutNewsLetter.responseDiv.dataset.errorEmailEmpty;
      BlockAboutNewsLetter.errorEmailWrong =
        BlockAboutNewsLetter.responseDiv.dataset.errorEmailWrong;
      BlockAboutNewsLetter.errorSubscriber =
        BlockAboutNewsLetter.responseDiv.dataset.errorSubscriber;

      // console.log("1: ", BlockAboutNewsLetter.successText);
      // console.log("2: ", BlockAboutNewsLetter.errorTerms);
      // console.log("3: ", BlockAboutNewsLetter.errorGeneric);
      // console.log("4: ", BlockAboutNewsLetter.errorEmailEmpty);
      // console.log("5: ", BlockAboutNewsLetter.errorEmailWrong);
      // console.log("6: ", BlockAboutNewsLetter.errorSubscriber);
    }

    // submit
    if (BlockAboutNewsLetter.formEl) {
      BlockAboutNewsLetter.formEl.addEventListener("submit", (e) => {
        e.preventDefault();

        // get values
        let email = BlockAboutNewsLetter.emailEl.value;
        let doubleOptId = BlockAboutNewsLetter.doubleOptIdEl.value;
        let policy = BlockAboutNewsLetter.policyEl.checked;

        if (!policy) {
          if (BlockAboutNewsLetter.responseDiv)
            BlockAboutNewsLetter.responseDiv.innerHTML =
              BlockAboutNewsLetter.errorTerms;
        } else {
          BlockAboutNewsLetter.ajaxRequest(email, doubleOptId);
        }
      });
    }
  },

  ajaxRequest: (email, doubleOptId) => {
    const $ = jQuery;

    $.ajax({
      type: "post",
      dataType: "json",
      url: "https://ui.ungpd.com/Api/Subscriptions/dd32c31b-4cd6-41e3-8ec3-d70d98d0b2e9/ajax",
      data: {
        ListIds: ["d9569649-1363-45c7-9d3c-42f95da584b7"],
        Contact: {
          Email: email,
        },
        ConsentText:
          "Jag vill få relevant information från Net Zero Industry till min inkorg. Net Zero Industry ska inte dela eller sälja mina personuppgifter. Jag kan avsluta prenumerationen när som helst.",
        DoubleOptIn: {
          Issue: { IssueId: doubleOptId },
        },
      },
      statusCode: {
        200: function (res) {
          console.log("success");
          BlockAboutNewsLetter.responseDiv.innerHTML =
            BlockAboutNewsLetter.successText;
        },
        400: function (xhr, status, error) {
          console.log("400");
          const message = xhr.responseJSON.Message;
          console.log(message);
          console.log(xhr.responseJSON);

          let response = BlockAboutNewsLetter.errorGeneric;

          if (message == "No contact information provided") {
            response = BlockAboutNewsLetter.errorEmailEmpty;
          } else if (message == "Invalid email") {
            response = BlockAboutNewsLetter.errorEmailWrong;
          } else if (message == "Subscription already exists") {
            response = BlockAboutNewsLetter.errorSubscriber;
          } else {
            response = message;
          }

          BlockAboutNewsLetter.responseDiv.innerHTML = response;
        },
      },
    });

    return false;
  },
};

export default BlockAboutNewsLetter;
